import { useState } from "react";
import Button from "../UI/Button";
import Card from "../UI/Card";
import styles from "./NewExpense.module.css";
import NewExpenseForm from "./NewExpenseForm";
const NewExpense = (props) => {
  const [
    showNewExpenseForm,
    setShowNewExpenseForm,
  ] = useState(false);
  const showNewExpenseFormHandler = () => {
    setShowNewExpenseForm(true);
  };
  const saveExpenseDataHandler = (
    ExpenseData
  ) => {
    let formattedAmount;
    let formattedTitle;
    console.log(ExpenseData.enteredTitle.length);
    if (ExpenseData.enteredAmount.length <= 6) {
      formattedAmount = ExpenseData.enteredAmount;
    } else {
      formattedAmount = ExpenseData.enteredAmount;
      formattedAmount =
        formattedAmount.slice(0, 6) + "...";
    }
    if (ExpenseData.enteredTitle.length <= 30) {
      formattedTitle = ExpenseData.enteredTitle;
    } else {
      formattedTitle = ExpenseData.enteredTitle;
      formattedTitle =
        formattedTitle.slice(0, 30) + "...";
    }

    const newExpenseData = {
      id: Math.random(),
      title: formattedTitle,
      amount: formattedAmount,
      date: new Date(ExpenseData.enteredDate),
    };
    props.onsaveExpenseData(newExpenseData);
  };
  return (
    <Card className={styles["new-expense"]}>
      {!showNewExpenseForm && (
        <Button
          type="button"
          className={
            styles["new-expense__button"]
          }
          onClick={showNewExpenseFormHandler}
        >
          Add New Expense
        </Button>
      )}
      {showNewExpenseForm && (
        <NewExpenseForm
          onsaveExpenseData={
            saveExpenseDataHandler
          }
        />
      )}
    </Card>
  );
};

export default NewExpense;
